export const defaultSideBarLinks = [
  { title: 'Unexplained Wealth Orders', link: '/unexplained-wealth-orders' },
]

export const suggestionLink = {
  title: 'More Cases and Contempts',
  link: '/',
}
